import { render, staticRenderFns } from "./Robotics.vue?vue&type=template&id=dc21face&scoped=true"
import script from "./Robotics.vue?vue&type=script&lang=js"
export * from "./Robotics.vue?vue&type=script&lang=js"
import style0 from "./Robotics.vue?vue&type=style&index=0&id=dc21face&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc21face",
  null
  
)

export default component.exports